<template>
  <div id="Cardtitle">
    <div class="titlebox">{{msg}}</div>
  </div>
</template>

<script>
export default {
  name: "Cardtitle",
  props: ["msg"],
  data() {
    return {};
  },
  mounted() {
    // console.log(this.msg);
  },
  methods: {},
};
</script>
<style scoped>
#Cardtitle {
  margin-top: 1vh;
  margin-bottom: 1vh;
  
}
.titlebox {
  border-left: 5px solid blue;
  line-height: 3vh;
  display: table-cell;
  padding-left: 1vw;
  font-weight: bold;
  font-size: 18px;
  vertical-align: bottom;
}
</style>


// WEBPACK FOOTER //
// src/components/Cardtitle/Cardtitle.vue